import { useEffect } from "react";
import { useTheme } from "next-themes";
import { Button } from "./ui/button";
// import { Input } from "./ui/input";
// import { Textarea } from "./ui/textarea";
// import { Label } from "./ui/label";
// import { Card, CardContent } from "./ui/card";

interface ContactUsProps {
  onNavigate: (page: string) => void;
}

export function ContactUs({ onNavigate }: ContactUsProps) {
  const { theme } = useTheme();
  const logoSrc = theme === "dark" ? "/logo_white.png" : "/logo.png";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const navigate = (url: string, page: string) => {
    window.history.pushState({}, "", url);
    onNavigate(page);
  };

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     message: ""
//   });

//   const handleChange = (field: string, value: string) => {
//     setForm(prev => ({ ...prev, [field]: value }));
//   };

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     alert("Your message has been sent. We will get back to you soon.");
//     setForm({ name: "", email: "", message: "" });
//   };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* HEADER */}
      <header className="border-b sticky top-0 z-50 bg-white/80 dark:bg-slate-900/80 backdrop-blur">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/", "landing")}>
            <img src={logoSrc} alt="Swimnerd Logo" className="h-10 w-auto" />
          </button>

          <nav className="flex items-center gap-4">
            <Button variant="ghost" onClick={() => navigate("/find-pool", "find-pool")}>Find Pool</Button>
            <Button variant="ghost" onClick={() => navigate("/blog", "blog")}>Blog</Button>
            <Button variant="ghost" onClick={() => navigate("/signin", "signin")}>Sign In</Button>
            <Button onClick={() => navigate("/signup", "signup")}>Get Started</Button>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="relative overflow-hidden text-white">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,hsl(var(--primary)),hsl(var(--primary)/0.85))]" />
        <div className="relative max-w-7xl mx-auto px-6 py-24">
          <h1 className="text-5xl font-bold mb-4 max-w-3xl">Contact Us</h1>
          <p className="text-lg text-white/90 max-w-2xl">
            Questions, feedback, or support — our team is here to help.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <main className="flex-1 bg-muted/30">
        
      </main>

      {/* FOOTER */}
      <footer className="border-t text-center py-8 text-sm text-muted-foreground">
        © {new Date().getFullYear()} Swimnerd. All rights reserved.
      </footer>
    </div>
  );
}
